import { useState, useEffect } from "react";

// AWS
import { API, Storage, Auth } from "aws-amplify";

function useGetAllLoanRequest({ ...query }) {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData(query);
  }, []);

  function tryParseJSON(jsonString) {
    try {
      var o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {}

    return false;
  }
  const getStatments = async (statement) => {
    var arr = [];

    for (let i = 0; i < statement.length; i++) {
      let value = await Storage.get(statement[i]);
      arr.push({ value: value, title: statement[i] });
    }
    return arr;
  };

  const getData = async (query = {}, options = { sortBy: "" }) => {
    try {
      setLoading(true);
      const datas = await API.get("MoneyHubAdmin", "/transferLoan", {
        queryStringParameters: {
          ...query,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(datas.body);
      let newDatas = await Promise.all(
        parseData?.Items?.map(async (data, index) => {
          return {
            ...data,
            // disabled_import: true,
            originalFileBuro: data.fileBuro,
            fileBuro: !data.fileBuro ? "" : await Storage.get(data?.fileBuro),
            creditUri: !data.creditUri ? "" : await Storage.get(data?.creditUri),
            attachment: !data.attachment
              ? ""
              : await Storage.get(data.attachment),
            pdpaUri: !data.pdpaUri ? "" : await Storage.get(data?.pdpaUri),
            contractUri: !data.contractUri
              ? ""
              : await Storage.get(data?.contractUri),
            statementUris: await getStatments(tryParseJSON(data?.statementUris)),
            sort: +index + 1,
          };
        })
      );

      if (options.sortBy) {
        newDatas = newDatas.sort((a, b) => b.sort - a.sort);
      }
      setCount(datas.count);
      setDatas(newDatas);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    datas,
    setDatas,
    count,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useGetAllLoanRequest;
